import { render } from "./LlistatInformes.vue?vue&type=template&id=6351aa88&scoped=true"
import script from "./LlistatInformes.vue?vue&type=script&lang=js"
export * from "./LlistatInformes.vue?vue&type=script&lang=js"

import "./LlistatInformes.vue?vue&type=style&index=0&id=6351aa88&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6351aa88"]])

export default __exports__